import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
//import { DatepickerOptions } from 'ng2-datepicker';
import { OperationsService } from '../../../services/operations.service';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';

@Component({
  selector: 'app-jobs-handover',
  templateUrl: './jobs-handover.component.html',
  styleUrls: ['./jobs-handover.component.scss']
})
export class JobsHandoverComponent implements OnInit {

  constructor(private operationService: OperationsService, private toasterService: ToastrService) { }
  // dateOptions: DatepickerOptions = {
  //   format: 'YYYY-MM-DD',
  //   formatTitle: 'MMMM YYYY',
  //   formatDays: 'dd',
  //  };
  dateFrom ="";
  dateTo = "";
  courierId = "";
  public pagger: number = 0;
  pageCount: number = 0
  pagesContainer: any[] = new Array(0);
  data: any[];
  ngOnInit() {
  }
  convertoToDate(date) {
    if (date)
      return moment(date).format('YYYY/MM/DD');
    return '-';
  }
  prevPage() {
    this.pagger--;
    this.search(10, this.pagger * 10);
  }

  nextPage() {
    this.pagger++;
    this.search(10, this.pagger * 10);
  }
  getSearchPage(pagger) {
    this.pagger = pagger;
    this.search(10, this.pagger * 10);
  }
  _dateFrom = "";
  _dateTo = "";
  initlizeSearch() {
    this.pagger = 0;
    this.pageCount = 0
    this.pagesContainer = new Array(0);
    this.data = [];
    this._dateFrom = this.convertoToDate(this.dateFrom);
    this._dateTo = this.convertoToDate(this.dateTo);
    this.search(10,0)
  }
  search(take, skip) {
   
    this.operationService.searchFleetersJobs(this._dateFrom, this._dateTo, this.courierId, take, skip, (data) => {
      if (data.errorMessage != null) {
        this.toasterService.error(data.errorMessage);
      }
      this.data = data.data;
      this.pageCount = data.count;
      this.pagesContainer = new Array(Math.ceil(this.pageCount / 10))
    }, (err) => {
      //console.log(err);
    })
  }
  shipmentsData =[]
 @ViewChild('modalbtn', { read: false }) modalbtn: ElementRef;
  getSpotShipmentsDetails(courierId,jobRefrence) {
    this.operationService.getSpotShipmentsDetailsByJobReference(jobRefrence, courierId, (res) => {
      if (res.length > 0) {
        this.shipmentsData = res;
        this.modalbtn.nativeElement.click()
        
      }
      
    }, (err) => {

    })
  }
}
